import { Status, StatusEnum } from './enums/StatusEnum';

export type Destination = {
  id: string;
  encoderId: string;
  streamKey: string;
  streamUrl: string;
  createdUtc: string;
  created: string;
  updatedUtc: string;
  updated: string;
  deleted: string;
  deletedUtc: string;
  broadcastStartedUtc: string;
  broadcastStarted: string;
  broadcastEndedUtc: string;
  broadcastEnded: string;
  status: Status;
  name: string;
  languageIsoCode: string;
};

export type Destinations = Array<Destination>;

export const DefaultDestination: Destination = {
  id: '',
  encoderId: '',
  created: '',
  createdUtc: '',
  updated: '',
  updatedUtc: '',
  deleted: '',
  deletedUtc: '',
  broadcastStartedUtc: '',
  broadcastStarted: '',
  broadcastEndedUtc: '',
  broadcastEnded: '',
  name: '',
  streamKey: '',
  streamUrl: '',
  languageIsoCode: 'en-us',
  status: StatusEnum.Created,
};
